import React, { useState } from "react";
import axios from "axios";
import config from "../config";
import { addContactSubmissionFromPublicForm } from "../MGMT/contactStore";

function buildApiUrl(path) {
  const trimmed = config.apiUrl?.trim();
  if (trimmed) {
    const base = trimmed.replace(/\/+$/, "");
    const p = path.replace(/^\/+/, "");
    return `${base}/${p}`;
  }
  return `/api/public/${path.replace(/^\/+/, "")}`;
}

function ContactUs() {
  const [successMsg, setSuccessMsg] = useState("");
  const [variantMsg, setVariantMsg] = useState("");

  const [registration, setRegistration] = useState({
    fullname: "",
    emailAddress: "",
    message: "",
    phoneNumber: "",
    website: "", // honeypot — humans never see this field; bots auto-fill it
  });

  const handleChangeForRegistration = (e) => {
    setRegistration({ ...registration, [e.target.name]: e.target.value });
  };

  const handleRegistration = async (e) => {
    e.preventDefault();
    setSuccessMsg("");
    setVariantMsg("");
    try {
      const res = await axios.post(
        buildApiUrl("contactus"),
        registration,
        { timeout: 15000 }
      );
      if (res.data.success === true) {
        addContactSubmissionFromPublicForm({ ...registration });
        setSuccessMsg(res.data.objects[0]);
        setVariantMsg("success");
      } else {
        setSuccessMsg(res.data.message);
        setVariantMsg("error");
      }
      setRegistration({
        fullname: "",
        emailAddress: "",
        message: "",
        phoneNumber: "",
        website: "",
      });
    } catch (error) {
      console.error(error);
      setSuccessMsg(
        "We could not send your message right now. Please try again or call us."
      );
      setVariantMsg("error");
    }
  };

  return (
    <section className="bizmak-section bizmak-section-alt" id="contact">
      <div className="container">
        <h2 className="page-section-heading text-center text-blue mb-0">
          Contact us
        </h2>
        <p className="section-intro">
          Tell us about your project or requirement — we typically respond
          within one business day.
        </p>
        <div className="divider-custom">
          <div className="divider-custom-line" />
          <div className="divider-custom-icon">
            <i className="fas fa-star" aria-hidden="true" />
          </div>
          <div className="divider-custom-line" />
        </div>

        <div className="row justify-content-center g-4 g-xl-5">
          <div className="col-lg-5">
            <div className="bizmak-contact-aside h-100">
              <h3 className="h5 fw-bold mb-3" style={{ color: "var(--bizmak-text)" }}>
                Direct lines
              </h3>
              <p className="mb-2">
                <strong>Phone</strong>
                <br />
                <a href="tel:+14439515651">443-951-5651</a>
              </p>
              <p className="mb-2 mt-3">
                <strong>Office</strong>
                <br />
                Catonsville, MD 21228
              </p>
              <p className="mb-0 mt-4 small text-muted">
                Government buyers: use the form or call to reach Carolina
                Fernandez, President, directly — or download our capability
                statement above.
              </p>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="bizmak-contact-panel">
              {successMsg && (
                <div
                  className={`bizmak-alert ${
                    variantMsg === "success" ? "success" : "error"
                  }`}
                  role="status"
                >
                  {successMsg}
                </div>
              )}
              <form id="contactForm" onSubmit={handleRegistration} noValidate>
                {/* Honeypot: hidden from humans, bots fill it and get rejected */}
                <div
                  style={{
                    position: "absolute",
                    left: "-9999px",
                    height: 0,
                    overflow: "hidden",
                  }}
                  aria-hidden="true"
                >
                  <label htmlFor="website">Website</label>
                  <input
                    id="website"
                    name="website"
                    type="text"
                    tabIndex={-1}
                    autoComplete="off"
                    value={registration.website}
                    onChange={handleChangeForRegistration}
                  />
                </div>
                <div className="form-floating mb-3">
                  <input
                    className="form-control"
                    id="fullname"
                    name="fullname"
                    type="text"
                    placeholder="Name"
                    autoComplete="name"
                    value={registration.fullname}
                    onChange={handleChangeForRegistration}
                  />
                  <label htmlFor="fullname">Full name</label>
                </div>
                <div className="form-floating mb-3">
                  <input
                    className="form-control"
                    id="emailAddress"
                    name="emailAddress"
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    value={registration.emailAddress}
                    onChange={handleChangeForRegistration}
                  />
                  <label htmlFor="emailAddress">Email address</label>
                </div>
                <div className="form-floating mb-3">
                  <input
                    className="form-control"
                    id="phoneNumber"
                    name="phoneNumber"
                    type="tel"
                    placeholder="Phone"
                    autoComplete="tel"
                    value={registration.phoneNumber}
                    onChange={handleChangeForRegistration}
                  />
                  <label htmlFor="phoneNumber">Phone number</label>
                </div>
                <div className="form-floating mb-4">
                  <textarea
                    className="form-control"
                    id="message"
                    name="message"
                    placeholder="Message"
                    style={{ minHeight: "10rem" }}
                    value={registration.message}
                    onChange={handleChangeForRegistration}
                  />
                  <label htmlFor="message">Message</label>
                </div>
                <button
                  className="btn btn-primary btn-lg px-5 text-uppercase"
                  type="submit"
                >
                  Send message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
